import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import sidebarlogo from "../../assets/images/sidebarLogo.png";
import promptLogo from "../../assets/images/promptLogo.png";
import promptDisabledLogo from "../../assets/images/VectorDisabled.png";
import chatLogo from "../../assets/images/chatBot.png";
import chatDisabledLogo from "../../assets/images/chatBotDisabled.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logout from "../../assets/images/Logout1.png";
import logoutConfirm from "../../assets/images/logoutIcon.png";
import minMaxIcon from "../../assets/images/menu.png";
import { toast } from "react-toastify";
import { env } from "../../environment.template";
// import { env } from "../../environment";


function Sidebar({ onToggleMinimize }) {
  const location = useLocation();
  
  // Initialize state from localStorage
  const [isMinimized, setIsMinimized] = useState(() => {
    const saved = localStorage.getItem("sidebarMinimized");
    return saved=='true'; // Return true if saved state is 'true'
  });

  // Update localStorage whenever isMinimized changes
  useEffect(() => {
    localStorage.setItem("sidebarMinimized", isMinimized);
  }, [isMinimized]);

  const toggleSidebar = () => {
    // setIsMinimized((prev) => !prev); // Toggle the state
    const newState = !isMinimized;
    setIsMinimized(newState);
    onToggleMinimize(newState);
  };

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token"); // Retrieve token
      const response = await fetch(`${env.baseURL}/app-users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include auth token
        },
      });
      if (response.ok) {
        toast.success("Logout successful!");
      } else {
        toast.success("Logout successful!");
      }
    } catch (error) {
      toast.success("Logout successful!");
    }
  
    // Clear local storage and redirect
    localStorage.clear();
    setShowModal(false);
    navigate("/sign-in");
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <div className={`sidebar ${isMinimized ? "minimized" : ""}`}>
        <div className="logo">
          <div className="sidebar-title">
          <button onClick={toggleSidebar} className="toggle-button">
            {<img height="20px" width="20px" src={minMaxIcon} alt="" />}
          </button>
            {!isMinimized && (
              <>
              <img style={{ width: "17%" }} src={sidebarlogo} alt="Logo" />
                <span>DOSSIER</span>
                <span className="sidebar-sub-title">GenAI</span>
              </>
            )}
          </div>
        </div>

        <div className="navigation">
          <Link to="/dashboard">
            <button
              className={`nav-item ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              {location.pathname === "/dashboard" ? (
                <img src={promptLogo} alt="Prompt Page Logo" />
              ) : (
                <img src={promptDisabledLogo} alt="Prompt Page Logo" />
              )}
              {!isMinimized && "Dossier Generator"}
            </button>
          </Link>
{/* 
          <Link to="/chat">
            <button
              className={`nav-item ${
                location.pathname === "/chat" ? "active" : ""
              }`}
            >
              {location.pathname === "/chat" ? (
                <img src={chatLogo} alt="Chat Page Logo" />
              ) : (
                <img src={chatDisabledLogo} alt="Chat Page Logo" />
              )}
              {!isMinimized && "Dossier Chat"}
            </button>
          </Link> */}
       {/* <div style={{ height: "100%",position:'relative', bottom: "0px" }}> */}
         <div onClick={handleOpenModal} style={{cursor: "pointer"}}  className={`nav-item-logout ${isMinimized ? "minimized" : ""}`}>
          {!isMinimized && <p className="profile-name">Log Out</p>}
          <span>
            <img style={{ position:'relative',top:'2px' }} src={logout} alt="Logout" />
            </span>
        {/* </div> */}
        </div>
        </div>

      </div>
      
      <LogoutModal 
        show={showModal} 
        handleLogout={handleLogout} 
        handleClose={handleCloseModal} 
      />

    </div>
  );
}

export default Sidebar;
const LogoutModal = ({ show, handleLogout, handleClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={logoutConfirm} alt="Logout Icon" /> {/* Optional: replace with your logout icon */}
        </div>
        <div className="logout-text">Are you sure you want to LogOut?</div>
        <div className="modal-buttons">
          <button onClick={handleLogout} className="yes-btn">Yes</button>
          <button onClick={handleClose} className="no-btn">No</button>
        </div>
      </div>
    </div>
  );
};